import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  return <section className="bg-bbq-surface py-24 px-4 border-t border-white/5 relative" data-id="element-98">
      <div className="max-w-4xl mx-auto text-center" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-bbq-dark p-8 md:p-12 rounded-3xl border border-bbq-ember/30 shadow-[0_0_50px_rgba(232,98,45,0.1)] relative overflow-hidden" data-id="element-100">
          {/* Decorative top bar */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-bbq-ember-dark via-bbq-ember to-bbq-gold" data-id="element-101"></div>

          <h2 className="text-2xl md:text-3xl text-gray-300 mb-6" data-id="element-102">
            Olvida pagar los $65.800 que valdría todo esto por separado. Ni
            siquiera pagarás los $35.000 que cuesta un libro físico.
          </h2>

          <p className="text-bbq-gold font-display text-xl uppercase tracking-widest mb-8" data-id="element-103">
            Por tiempo limitado — Especial Día del Padre
          </p>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-104">
            <span className="text-gray-500 text-lg line-through mb-2" data-id="element-105">
              $65.850 CLP
            </span>
            <div className="flex items-start justify-center gap-2" data-id="element-106">
              <span className="text-3xl font-bold text-white mt-2" data-id="element-107">$</span>
              <span className="text-7xl md:text-8xl font-display font-bold text-white tracking-tighter" data-id="element-108">
                6.390
              </span>
              <span className="text-xl text-gray-400 mt-auto mb-3" data-id="element-109">CLP</span>
            </div>
            <p className="text-gray-400 mt-3 text-sm uppercase tracking-wider" data-id="element-110">
              Pago único - Acceso de por vida
            </p>
          </div>

          <button onClick={() => {
          trackAddToCart();
          window.location.href = 'https://www.merlanis.com/cart/53892945052016:1';
        }} className="w-full md:w-auto bg-bbq-ember hover:bg-bbq-ember-dark text-white font-display text-xl md:text-2xl uppercase tracking-wider py-5 px-12 rounded-md transition-all duration-300 shadow-[0_0_30px_rgba(232,98,45,0.4)] hover:shadow-[0_0_50px_rgba(232,98,45,0.6)] transform hover:-translate-y-1 flex items-center justify-center gap-3 mx-auto" data-id="element-111">
            SÍ, QUIERO ACCESO INMEDIATO
            <ArrowRight size={24} data-id="element-112" />
          </button>

          <div className="mt-8 flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-113">
            <ShieldCheck size={16} className="text-green-500" data-id="element-114" />
            <span data-id="element-115">Pago 100% seguro y encriptado</span>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-12 text-gray-400 max-w-2xl mx-auto italic" data-id="element-116">
          ¿Por qué este precio? Queremos que este sea el regalo más accesible y
          valorado de Chile. Pero ojo, una vez que pase el Día del Padre, el
          precio volverá a su valor normal.
        </motion.p>
      </div>
    </section>;
}